var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2493 7.33203C19.2493 5.81325 18.0182 4.58203 16.4993 4.58203H9.16602C7.64724 4.58203 6.41602 5.81325 6.41602 7.33203V18.332C6.41602 19.8509 7.64724 21.082 9.16602 21.082H16.4993C18.0182 21.082 19.2493 19.8509 19.2493 18.332V7.33203ZM17.416 7.33203C17.416 6.82577 17.0056 6.41536 16.4993 6.41536H9.16602C8.65976 6.41536 8.24935 6.82577 8.24935 7.33203V18.332C8.24935 18.8383 8.65976 19.2487 9.16602 19.2487H16.4993C17.0056 19.2487 17.416 18.8383 17.416 18.332V7.33203Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.7513H14.6667C15.1729 2.7513 15.5833 2.34089 15.5833 1.83464C15.5833 1.32838 15.1729 0.917969 14.6667 0.917969H5.5C3.98122 0.917969 2.75 2.14919 2.75 3.66797V16.5013C2.75 17.0076 3.16041 17.418 3.66667 17.418C4.17292 17.418 4.58333 17.0076 4.58333 16.5013V3.66797C4.58333 3.16171 4.99374 2.7513 5.5 2.7513Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.1abd88a3584f5d8aa0bf74fea6f56869.svg";
export { ForwardRef as ReactComponent };